//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('actStatus', {
//        templateUrl: 'views/components/views/actStatus/actStatus.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'actStatusService', 'skillsCertificateTypeService', 'rememberService', function ($stateParams, stateService, utilityService, translateService, modalService, actStatusService, skillsCertificateTypeService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let actStatusKeyno = $stateParams.actstatus_keyno;

//            let variableNames = {
//                actstatus_name: ''
//            };

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                glyphiconButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-left', color: 'primary', type: 'primary', onClick: () => goToFunc('selectglyphicon') }
//                ],
//                edit: {},
//                selectListGlyphicons: [],
//                selectListHexColours: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await actStatusService.getEdit({ actstatus_keyno: actStatusKeyno }))[0];
//            }

//            async function loadGlyphicons() {
//                vm.model.selectListGlyphicons = await skillsCertificateTypeService.listGlyphicons();

//                //vm.model.selectListGlyphicons[0].item_name = vm.model.selectListGlyphicons[0].item_name + ' &#xf640;';
//            }

//            async function loadHexColors() {
//                vm.model.selectListHexColours = await skillsCertificateTypeService.listHexColors();
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'actstatus_name':
//                        if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

//                        variableValue = vm.model.edit[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region SHOW GLYPHICON SYMBOL FUNCTION

//            vm.showGlyphiconSymbol = function (value) {
//                vm.model.selectListGlyphicons.forEach((glyph) => {
//                    if (vm.model.edit.glyphicon === glyph.item_id) {
//                        vm.model.edit.glyphicon = glyph.item_glyphicon;

//                        showColour(value);
//                    }
//                });
//            }

//            // #endregion SHOW GLYPHICON SYMBOL FUNCTION

//            // #region SHOW COLOUR FUNCTION

//            function showColour(value) {
//                vm.model.edit.glyphicon_color = value;

//                vm.model.selectListHexColours.forEach((hex) => {
//                    if (vm.model.edit.glyphicon_color === hex.hexcolor) {
//                        vm.model.edit.glyphicon_color = hex.hexcolor;
//                    }
//                });
//            }

//            // #endregion SHOW COLOUR FUNCTION

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            function goToFunc(state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'selectglyphicon':
//                        Promise.all([
//                            rememberFunc('actstatus_name')
//                        ]).then(() => {
//                            go();
//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                actStatusService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadGlyphicons();
//                loadHexColors();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
